<ng-template
  [ngIf]="subHeaderTemplate"
  [ngTemplateOutlet]="subHeaderTemplate"
></ng-template>
<div
  class="ad-doc-viewer-tool"
>
  <ng-container
    *ngIf="
      fileExtension !== 'youtube' &&
      fileExtension !== 'vimeo' &&
      isValid &&
      !isLoading &&
      !noFile &&
      enableDefaultViewer() === false
    "
  >
    <span *ngIf="!isHideZoom">
      <i class="fa fa-search-minus" (click)="zoomOut()"></i>
    </span>
    <span *ngIf="!isHideZoom">
      <i class="fa fa-search-plus" (click)="zoomIn()"></i>
    </span>
    <span class="ad-doc-viewer-print" *ngIf="enablePrint === true">
      <i
        class="fa fa-print"
        (click)="print()"
        [attr.disabled]="excelPrintLoading ? true : null"
      ></i>
      <i
        class="fa fa-spinner ad-doc-viewer-loading-icon"
        *ngIf="excelPrintLoading"
        aria-hidden="true"
      ></i>
    </span>
    <span *ngIf="enableDownload === true">
      <i class="fa fa-download" (click)="download()"></i>
    </span>
  </ng-container>
  <ng-container
      *ngIf="
          !(
              fileExtension !== 'youtube' &&
              fileExtension !== 'vimeo' &&
              isValid &&
              !isLoading &&
              !noFile &&
              enableDefaultViewer() === false
          ) === false
      "
  >
      <span class="no-border"> &nbsp; </span>
  </ng-container>
</div>
<div class="ad-doc-viewer-content" [ngClass]="{'rel':fileExtension === '.pdf'}" *ngIf="isValid && !isLoading && !noFile">
  <ad-pdf-viewer
    #viewer
    *ngIf="fileExtension === '.pdf'"
    [fileSrc]="fileSrc"
  ></ad-pdf-viewer>
  <ad-img-viewer
    #viewer
    *ngIf="imgViewerExtensions.indexOf(fileExtension) !== -1"
    [itemGetter]="itemGetter"
    [documentId]="documentId"
  >
  </ad-img-viewer>
  <ad-excel-viewer
    #viewer
    *ngIf="fileExtension === '.xls' || fileExtension === '.xlsx'"
    [documentId]="documentId"
  >
  </ad-excel-viewer>
  <ad-video-viewer
    #viewer
    *ngIf="fileExtension === 'youtube' || fileExtension === 'vimeo'"
    [fileExtension]="fileExtension"
    [videoUrl]="videoUrl"
  >
  </ad-video-viewer>
  <div class="ad-doc-viewer-content flex-vh-c" *ngIf="enableDefaultViewer()">
    <div class="tc">
      <img src="assets/images/unsupported-file.svg" />

      <div class="mt1em mb1em">
        This file cannot be displayed in the viewer.
      </div>

      <div class="mb1em">Please click to download the document.</div>
      <div>
        <a (click)="download()"> Download </a>
      </div>
    </div>
  </div>
</div>

<div
  class="ad-doc-viewer-content flex-vh-c"
  *ngIf="!isValid && !isLoading && !noFile"
>
  <div class="tc">
    <img src="assets/images/unsupported-file.svg" />

    <div class="mt1em mb1em">
      This protected file cannot be displayed in the viewer.
    </div>

    <div class="mb1em">Please click to download the document.</div>
    <div>
      <ad-button (onClick)="download()"> Download </ad-button>
    </div>
  </div>
</div>
<div class="ad-doc-viewer-content flex-vh-c" *ngIf="noFile && !isLoading">
  <div class="tc">
    <img src="assets/images/unsupported-file.svg" />

    <div class="mt1em mb1em">This file does not exist.</div>
  </div>
</div>
